import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import Header from "./Header";
import Footer from "./Footer";
import { API_KEY, USERNAME, SOURCE, DESTINATION, PASSWORD } from "./config";
import { toast } from "react-toastify";

const PageContainer = styled.div`
  background-color: #ececec;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  @media (max-width: 480px) {
    background-color: #ececec;
    min-height: 100vh;
  }
`;

const FormContainer = styled.div`
  width: 60%;
  flex: 1;
  margin: 0 auto;
  @media (max-width: 480px) {
    width: 90%;
    margin: 0 auto;
    flex: 1;
    padding: 20px;
  }
`;

const Form = styled.form`
  display: ${(props) => (props.submitted ? "none" : "flex")};
  flex-direction: column;
`;

const BoldLabel = styled.label`
  margin-bottom: 5px;
  font-weight: bold;
  color: darkgreen;
`;

const Heading = styled.p`
  color: darkorange;
  font-weight: 900;
  padding-bottom: 10px;
`;

const Input = styled.input`
  padding: 10px;
  margin-bottom: 10px;
  border: #ccc;
  border-radius: 0px;
  font-size: 16px;
  width: 100%;
  background-color: white;
  @media (max-width: 480px) {
    padding: 10px;
    margin-bottom: 10px;
    border: #ccc;
    border-radius: 0px;
    font-size: 16px;
    width: 100%;
    background-color: white;
  }
`;

const TextArea = styled.textarea`
  padding: 10px;
  height: 250px;
  margin-bottom: 10px;
  border: #ccc;
  border-radius: 0px;
  font-size: 16px;
  @media (max-width: 480px) {
    padding: 10px;
    height: 150px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    width: 100%;
  }
`;

const Heading2 = styled.h2`
  font-weight: 900;
  font-size: 30px;
  padding-bottom: 15px;
  @media (max-width: 480px) {
    font-weight: 900;
    font-size: 24px;
    padding-bottom: 15px;
  }
`;

const SubmitButton = styled.input`
  background-color: #e7f85e;
  color: darkgreen;
  font-weight: 900;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 100px;
  width: 152px;
  margin-top: 20px;
  &:hover {
    transform: scale(1.1);
    transition: transform 0.3s ease-in-out;
  }
`;

const Paragraph = styled.p`
  font-size: 16px;
  padding-bottom: 30px;
  color: gray;
`;

const ThankYouMessage = styled.p`
  display: ${(props) => (props.submitted ? "block" : "none")};
  color: darkgreen;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
`;

const EmailForm = () => {
  const form = useRef();
  const [submitted, setSubmitted] = useState(false);
  // const [authToken, setAuthToken] = useState(null);

  // useEffect(() => {
  //   const fetchAuthToken = async () => {
  //     try {
  //       const response = await fetch('/v1/ops/ins/auth/login', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           publicKey: API_KEY,
  //           password: PASSWORD,
  //           username: USERNAME
  //         }),
  //       });

  //       if (response.ok) {
  //         const data = await response.json();
  //         // console.log('data', data);
  //         setAuthToken(data.data); // store token for later
  //         // console.log('Auth token:', data.data);
  //       } else {
  //         console.error('Failed to fetch auth token:', await response.text());
  //       }
  //     } catch (error) {
  //       console.error('Error fetching auth token:', error);
  //     }
  //   };

  //   fetchAuthToken();
  // }, []);

  const sendEmail = async (e) => {
    e.preventDefault();

    // if (!authToken) {
    //   alert('You are not authenticated. Please try again later.');
    //   return;
    // }

    // check if all fields are filled
    const formFields = form.current.elements;
    let isEmpty = false;
    for (let field of formFields) {
      if (
        field.tagName === "INPUT" ||
        field.tagName === "TEXTAREA" ||
        field.tagName === "SELECT"
      ) {
        if (field.value.trim() === "") {
          isEmpty = true;
          break;
        }
      }
    }
    if (isEmpty) {
      toast.error("Please fill out all fields before sending.");

      return;
    }

    // track submissions based on email address
    const email = form.current.user_email.value;
    const submissionKey = `submissionCount_${email}`;
    const lastSubmissionKey = `lastSubmissionDate_${email}`;

    const lastSubmissionDate = localStorage.getItem(lastSubmissionKey);
    const now = new Date();
    const submissionCount = parseInt(
      localStorage.getItem(submissionKey) || "0",
      10
    );

    if (
      lastSubmissionDate &&
      new Date(lastSubmissionDate).toDateString() === now.toDateString()
    ) {
      if (submissionCount >= 5) {
        // 5 submissions per day
        alert("You have reached the maximum number of submissions for today.");
        return;
      }
    } else {
      // reset count if it's a new day
      localStorage.setItem(submissionKey, "0");
      localStorage.setItem(lastSubmissionKey, now.toISOString());
    }

    // gather form data
    const name = form.current.user_name.value;
    const mobile = form.current.mobile.value;
    const category = form.current.category.value;
    const message = form.current.message.value;

    // build email body with all contact details

    const emailBody = `
  <!DOCTYPE html>
  <html>
    <body>
      <p><strong>Name:</strong> ${name}</p>
      <p><strong>Email:</strong> ${email}</p>
      <p><strong>Mobile:</strong> ${mobile}</p>
      <p><strong>Category:</strong> ${category}</p>
      <p><strong>Message:</strong></p>
      <p>${message}</p>
    </body>
  </html>
`;

    const base64Credentials = btoa(`${USERNAME}:${PASSWORD}`);
    try {
      // send using Cequens API
      const emailResponse = await fetch("/v1/notification/email/send", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${authToken}`,
          Authorization: `Basic ${base64Credentials}`,
        },
        body: JSON.stringify({
          // source: SOURCE,
          to: SOURCE,
          subject: "New Contact Us Message",
          body: emailBody, // send the full body containing all fields
        }),
      });

      if (emailResponse.ok) {
        console.log("Email sent successfully!");
        setSubmitted(true);

        // update count
        const newCount = submissionCount + 1;
        localStorage.setItem(submissionKey, newCount.toString());
      } else {
        const errorData = await emailResponse.json();
        console.error("Failed to send email:", errorData);
        if (errorData.code === 422) {
          alert("Insufficient credit!");
        } else if (errorData.code === 400) {
          alert("Source identity does not exist!");
        } else {
          alert("Failed to send email. Please try again later.");
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        alert("Request timed out. Please try again.");
      } else {
        console.error("Unexpected error:", error);
        alert("Something went wrong. Please try again.");
      }
    }

    // mock call api and show success message
    // setSubmitted(true);
  };

  return (
    <PageContainer>
      <Header />
      <FormContainer>
        <br />
        <br />
        <Heading2>Contact Us</Heading2>
        <Form ref={form} onSubmit={sendEmail} submitted={submitted}>
          <Paragraph>
            We are happy to answer questions you may have, just send us a
            message and we will get back to you soon.
          </Paragraph>
          <Heading>Send Us Your Message</Heading>
          <BoldLabel>Name</BoldLabel>
          <Input type="text" placeholder="Enter Your Name" name="user_name" />
          <br />
          <BoldLabel>Email</BoldLabel>
          <Input
            type="email"
            placeholder="Enter Your e-mail"
            name="user_email"
          />
          <br />
          <BoldLabel>Mobile</BoldLabel>
          <Input type="tel" placeholder="(+02)" name="mobile" />
          <br />
          <BoldLabel>Category</BoldLabel>
          <select name="category">
            <option value="complain">Complain</option>
            <option value="Inquiry">Inquiry</option>
            <option value="Account Deletion">Account Deletion</option>
          </select>
          <br />
          <BoldLabel>Message</BoldLabel>
          <TextArea placeholder="Enter your message" name="message" />
          <br />
          <SubmitButton type="submit" value="Send" />
        </Form>
        <ThankYouMessage submitted={submitted}>
          Thank you for your message!
        </ThankYouMessage>
      </FormContainer>
      <Footer />
    </PageContainer>
  );
};

export default EmailForm;
